
import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#1f1f1f] text-[#d1d1d1] text-center px-4 sm:px-6 md:px-8 py-6 sm:py-8 border-t border-[#444] text-sm sm:text-[0.95rem]">
      <div className="flex flex-col items-center gap-2 max-w-6xl mx-auto">
        {/* App Info Line */}
        <p className="m-0 leading-relaxed text-[#aaaaaa] break-words">
          © 2025 <strong className="font-semibold">MAGICS</strong> · Crafted with ❤️ at{" "}
          <strong className="font-semibold">
            SCALE Lab, Indian Institute of Science (IISc), Bangalore
          </strong>
        </p>
        
        {/* Developer Credits */}
        <p className="m-0 leading-relaxed break-words">
          Credits:{" "}
          <a
            className="text-[#f06292] font-semibold no-underline transition-all duration-300 hover:text-white hover:underline"
            href="https://www.linkedin.com/in/sankar4/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sankar Balasubramanian &nbsp;
          </a>
          & &nbsp;
          <a
            className="text-[#f06292] font-semibold no-underline transition-all duration-300 hover:text-white hover:underline"
            href="https://www.linkedin.com/in/srinidhi-r-g-052a32226/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Srinidhi Ranjini Girish &nbsp;
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;